import Oidc from 'oidc-client';
import { auth } from './config';

var mgr = new Oidc.UserManager(getOidcConfig());

// Handle OpenID Connect callback events.
export function initiate (authEvent = null, errorEvent = null) {
  auth.authEvent = authEvent;
  auth.errorEvent = errorEvent;

  if (isSigninCallback()) {
    mgr
      .signinRedirectCallback()
      .then(function (user) {
        removeHash();
        if (authEvent) {
          authEvent(true, user);
        }
      })
      .catch(function (error) {
        removeHash();
        if (errorEvent) {
          errorEvent('Signin callback error. ' + error);
        }
        if (authEvent) {
          authEvent(false);
        }
      });
  } else if (isSignoutCallback()) {
    mgr
      .signoutRedirectCallback()
      .then(function (resp) {
        if (authEvent) {
          authEvent(false);
        }
      })
      .catch(function (error) {
        if (errorEvent) {
          errorEvent('Signout callback error. ' + error);
        }
        if (authEvent) {
          authEvent(false);
        }
      });
  } else {
    mgr
      .getUser()
      .then(function (user) {
        if (user) {
          if (auth.authEvent) {
            auth.authEvent(true, user);
          }
        } else {
          if (auth.authEvent) {
            auth.authEvent(false);
          }
        }
      })
      .catch(function (error) {
        if (auth.errorEvent) {
          auth.errorEvent('Get user error. ' + error);
        }
        if (auth.authEvent) {
          auth.authEvent(false);
        }
      });
  }
}

// Signin
export function signin () {
  mgr
    .clearStaleState()
    .then(function () {
      mgr.signinRedirect().catch(function (error) {
        if (auth.errorEvent) {
          auth.errorEvent('Signin error. ' + error);
        }
      });
    })
    .catch(function (error) {
      if (auth.errorEvent) {
        auth.errorEvent('Clear state error. ' + error);
      }
    });
}

// Signout
export function signout () {
  localStorage.removeItem('token');
  mgr.signoutRedirect().catch(function (error) {
    if (auth.errorEvent) {
      auth.errorEvent('Signout error. ' + error);
    }
  });
}

// Get the current authenticated user.
export function getUser () {
  return mgr.getUser();
}

// Create OIDC configuration for Azure AD B2C. Including ID Token and Token (Access Token) for the API.
function getOidcConfig () {
  var redirectUri = getRedirectUri();
  return {
    authority:
      auth.azureAdB2CInstance +
      '/' +
      auth.tenant +
      '/' +
      auth.signInPolicyId +
      '/v2.0',
    client_id: auth.clientId,
    redirect_uri: redirectUri,
    response_type: 'id_token token',
    scope: 'openid ' + auth.apiScope,
    post_logout_redirect_uri: redirectUri,
    loadUserInfo: false,
  };
}

function isSigninCallback () {
  if (window.location.href.indexOf('#') >= 0) {
    var hash = window.location.hash.toLowerCase();
    return (
      hash.indexOf('error_description') >= 0 ||
      hash.indexOf('error') >= 0 ||
      hash.indexOf('id_token') >= 0 ||
      hash.indexOf('access_token') >= 0
    );
  }
  return false;
}

function isSignoutCallback () {
  if (window.location.href.indexOf('?') >= 0) {
    var href = window.location.href.toLowerCase();
    return href.indexOf('state') >= 0;
  }
  return false;
}

function getRedirectUri () {
  return window.location.href.split('?')[0].split('#')[0];
}

function removeHash () {
  window.history.replaceState('', document.title, window.location.pathname);
}

export default auth;
